export default __webpack_public_path__ + "b7937b46fe2e5796e42c5cc7acc9675a.svg";